import { IHttpClient } from "@ezhou/common";
import { DataStore } from "@ezhou/core/lib/model/DataStore";

import { UserProfileSliceKey } from "../model/appConstants";
import { UserPreference, UserPreferenceKeyCurrentWorkingOrganization, UserPreferenceKeyRequest, UserProfile } from "../model/userProfile";

export const getUserProfileFromCache = (dataStore: DataStore): UserProfile => {
  const theCache = dataStore.getSliceValue<string>(UserProfileSliceKey);
  return JSON.parse(theCache);
};

export const NoExistingOrganizationId = -1;

export const getUserProfile = async (
  dataStore: DataStore,
  httpClient: IHttpClient,
  errorHandler?: (err: any) => void,
  useCache: boolean = false,
): Promise<UserProfile> => {
  if (useCache && dataStore.isSliceAvailable(UserProfileSliceKey)) {
    return getUserProfileFromCache(dataStore);
  }
  const ret = await httpClient.get<UserProfile>("system-info/get-current-user-info", errorHandler);
  if (ret && ret.userId) {
    if (ret.organizations && ret.organizations.length > 0) {
      let findUserPreference = false;
      const userPreferenceSetting = await httpClient.post<UserPreference, UserPreferenceKeyRequest>(`user-preferences/get-by-key`,
        { key: UserPreferenceKeyCurrentWorkingOrganization }, errorHandler);
      if (userPreferenceSetting && userPreferenceSetting.preferenceValue) {
        const preferredOrgId = parseInt(userPreferenceSetting.preferenceValue, 10);
        const preferredOrg = ret.organizations.find((org) => org.organizationId === preferredOrgId);
        if (preferredOrg) {
          ret.defaultOrganization = preferredOrg.organizationId;
          ret.defaultOrganizationInfo = preferredOrg;
          findUserPreference = true;
        }
      }
      if (!findUserPreference) {
        ret.defaultOrganization = ret.organizations[0].organizationId;
        ret.defaultOrganizationInfo = ret.organizations[0];
        httpClient.post(`user-preferences/save`, {
          key: UserPreferenceKeyCurrentWorkingOrganization,
          value: ret.defaultOrganization.toString(),
        });
      }
    }
    else {
      ret.defaultOrganization = NoExistingOrganizationId;
      ret.defaultOrganizationInfo = {
        organizationId: NoExistingOrganizationId,
        fullName: "NoExistingOrganization",
        shortName: "NoExistingOrganization",
        maximumTransactionCount: 0,
      }
    }
    if (dataStore.isSliceAvailable(UserProfileSliceKey)) {
      dataStore.saveSlice<string>(UserProfileSliceKey, JSON.stringify(ret));
    } else {
      dataStore.getSlice<string>(UserProfileSliceKey, "session", JSON.stringify(ret));
    }
  }
  return ret;
};
